<div class="div">
  <div class="div-2">
    <!-- {{placeHolders['LBL_TOTAL_DEALS']}} -->
    <div class="div-3">{{placeHolders['LBL_FILTER_DEALS']}}</div>
    <mat-icon (click)="closeDialog()">close</mat-icon>
  </div>
  <form [formGroup]="addForm" class="">
    <!-- <div class="div-4">
      <div class="div-5">Select tags</div>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6651221268d26d5f7c2459d3d86471df8c55372891d73df0aac8e167e05b80a?"
        class="img-2"
      />
    </div>
    <div class="div-6">
      <div class="div-7">
        <div class="div-8">
          <div class="div-9">Puma</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/57f6728b9abb08ca48a3c5a44dfce8050541257cf72d76f742f37dba5d9c5bc3?"
            class="img-3"
          />
        </div>
        <div class="div-10">
          <div class="div-11">Season</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/57f6728b9abb08ca48a3c5a44dfce8050541257cf72d76f742f37dba5d9c5bc3?"
            class="img-4"
          />
        </div>
        <div class="div-12">
          <div class="div-13">Sale</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/57f6728b9abb08ca48a3c5a44dfce8050541257cf72d76f742f37dba5d9c5bc3?"
            class="img-5"
          />
        </div>
      </div>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/f231dafc1b3fef336bbad007ade9614aba7f4b8bebd006e84c57ee6d4b1289a7?"
        class="img-6"
      />
    </div> -->
    <div class="div-14">
      <!-- <div class="div-15 pb-2">Category</div> -->
      <!-- <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6651221268d26d5f7c2459d3d86471df8c55372891d73df0aac8e167e05b80a?"
        class="img-7"
      /> -->
      <span>
      </span>
    </div>
    <div class="col-12">

      <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Category'" [data]="allCategory"
        bindLabel="category_type" bindValue="category_id" formControlName="category" (click)="setCategoryValue($event)">
      </ng-multiselect-dropdown>


      <!-- <ng-select placeholder="Select Category" [searchable]="false" [dropdownPosition]="'bottom'"
                 [items]="allCategory" bindLabel="category_type" bindValue="category_id"
                >
              </ng-select>   -->
      <!-- <div class="div-17">   
        
        <div class="div-18">
          <div class="div-19">Menswear</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/57f6728b9abb08ca48a3c5a44dfce8050541257cf72d76f742f37dba5d9c5bc3?"
            class="img-8"
          />
        </div>
        <div class="div-20">
          <div class="div-21">Footwear</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/57f6728b9abb08ca48a3c5a44dfce8050541257cf72d76f742f37dba5d9c5bc3?"
            class="img-9"
          />
        </div>
      </div> -->
      <!-- <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/f231dafc1b3fef336bbad007ade9614aba7f4b8bebd006e84c57ee6d4b1289a7?"
        class="img-10"
      /> -->
    </div>
    <!-- <div class="div-22">
      <div class="div-23">
        <div class="div-24">
          <div class="div-25">From</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4bbf3f6be6b4a0c4435de1895467800e2ddd5d0433d0ed53d3fd76dd73608aab?"
            class="img-11"
          />
        </div>
        <div class="div-26">
          
          <Input type="date"
          formControlName="fromDate" onkeydown="return false" placeholder="Select Date"
          style="border: 0px solid transparent;" class="col-8" ngDefaultControl />
         
        </div>
      </div>
      <div class="div-28">
        <div class="div-29">
          <div class="div-30">To</div>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/7ed5e5b41e4208efcad5291278fcc6a5d320da4b646dec769aa8dcc08b65947a?"
            class="img-13"
          />
        </div>
        <div class="div-31">
          <Input type="date" 
          formControlName="toDate" onkeydown="return false" placeholder="Select Date"
          style="border: 0px solid transparent;" class="col-8"  ngDefaultControl/>
         
        </div>
      </div>
    </div> -->
    <!-- <div class="div-33">
      <div class="div-34">Status</div>
    </div> -->
    <mat-radio-group class="mt--8" aria-label="Select an option" formControlName="status">
    <div class="div-35">
      <label><h6>{{placeHolders['LBL_STATUS']}}:</h6></label>
      <!-- <mat-radio-group class="mt--8" aria-label="Select an option" formControlName="status"> -->
        <mat-radio-button style="margin-left: 61px;" value="All">{{placeHolders['LBL_FILTER_ALL']}}</mat-radio-button>
        <mat-radio-button style="margin-left: 17px;" value="A">{{placeHolders['LBL_FILTER_ACTIVE']}}</mat-radio-button>
        <mat-radio-button value="S" style="margin-left: 12px;">{{placeHolders['LBL_FILTER_PAUSED']}}</mat-radio-button>
      <!-- </mat-radio-group> -->


      <!-- <div class="div-36">
        <img
          loading="lazy"
          srcset="..."
          class="img-16"
        />
        <div class="div-37">All</div>
      </div>
      <div class="div-38">
        <div class="div-39"></div>
        <div class="div-40">Active</div>
      </div>
      <div class="div-41">
        <div class="div-42"></div>
        <div class="div-43">Paused</div>
      </div>
      <div class="div-44">
        <div class="div-45"></div>
        <div class="div-46">Expired</div>
      </div> -->
    </div>
    <div class="Status_BtnNextLine">
      
        <mat-radio-button value="D">{{placeHolders['LBL_FILTER_DRAFT']}}</mat-radio-button>
        <mat-radio-button value="P">{{placeHolders['LBL_FILTER_PENDING']}}</mat-radio-button>
        <mat-radio-button value="E">{{placeHolders['LBL_FILTER_EXPIRED']}}</mat-radio-button>
     
    </div>
  </mat-radio-group>
    <!-- <div class="div-47">
      <div class="div-48">Budget</div>
   
    </div> -->
    <div class="div-49">

      <!-- <section class="example-section" [formGroup]="budget"> -->
      <!-- <h4>Select your Budget:</h4> -->
      <label><h6>{{placeHolders['LBL_BUDGET']}}({{currency}}):</h6></label>
      <mat-radio-group class="mt--8" aria-label="Select an option" formControlName="budget">
        <mat-radio-button value="0">0-1000</mat-radio-button>
        <mat-radio-button value="1">1001-9999</mat-radio-button>
        <mat-radio-button value="2">{{placeHolders['LBL_FILTER_ABOVE']}} 9999</mat-radio-button>
      </mat-radio-group>

      <!-- <mat-checkbox value="1" formControlName="budget1">$100-1000</mat-checkbox>
      <mat-checkbox value="2" formControlName="budget2">$10001-$9999</mat-checkbox>
      <mat-checkbox value="3" formControlName="budget3">$10001-$9999</mat-checkbox> -->
      <!-- </section> -->

      <!-- <div class="div-50">
        <div class="div-51"></div>
        <div class="div-52">$100-1000</div>
      </div>
      <div class="div-53">
        <img
          loading="lazy"
          srcset="..."
          class="img-18"
        />
        <div class="div-54">$10001-$9999</div>
      </div>
      <div class="div-55">
        <div class="div-56"></div>
        <div class="div-57">$10001-$9999</div>
      </div> -->
    </div>
    <!-- <div class="div-58">
      <div class="div-59">Actual spent</div>
    </div> -->
    <div class="div-60">
      <label><h6>{{placeHolders['LBL_FILTER_ACTUAL_SPENT']}}({{currency}}):</h6></label>
      <mat-radio-group class="mt--8" aria-label="Select an option" formControlName="actualSpent">
        <mat-radio-button value="0">0-1000</mat-radio-button>
        <mat-radio-button value="1">1001-9999</mat-radio-button>
        <mat-radio-button value="2">{{placeHolders['LBL_FILTER_ABOVE']}} 9999</mat-radio-button>
      </mat-radio-group>

      <!-- <mat-checkbox value="1" formControlName="actualSpent1">$100-1000</mat-checkbox>
      <mat-checkbox value="2" formControlName="actualSpent2">$10001-$9999</mat-checkbox>
      <mat-checkbox value="3" formControlName="actualSpent3">$10001-$9999</mat-checkbox> -->

      <!-- <div class="div-61">
        <img
          loading="lazy"
          srcset="..."
          class="img-20"
        />
        <div class="div-62">$100-1000</div>
      </div>
      <div class="div-63">
        <div class="div-64"></div>
        <div class="div-65">$10001-$9999</div>
      </div>
      <div class="div-66">
        <div class="div-67"></div>
        <div class="div-68">$10001-$9999</div>
      </div> -->
    </div>
    <div class="div-69">
      <button class="div-70" [disabled]="addForm.invalid" (click)="onReset()">{{placeHolders['LBL_BTN_RESET']}}</button>
      <button class="div-71" [disabled]="addForm.invalid" (click)="onSubmitFilter()">{{placeHolders['LBL_BTN_FILTER']}}</button>
    </div>
  </form>
</div>